import { useMemo } from 'react';
import { RadioGroup } from '../util/radioGroup';
import { RepairItemType } from '@/types/bodyAndPaint';

interface RepairItemSelectCardProps {
  itemIndex: number;
  info: RepairItemType;
  onChange: (newSelect: number) => void;
}
export const RepairItemSelectCard = ({
  itemIndex,
  info,
  onChange,
}: RepairItemSelectCardProps) => {
  const { repairItemName, selectValue, isInsurance, selectList, amountList } =
    useMemo(() => info, [info]);
  const isInsuranceStatus = isInsurance ? '保険適用可' : '保険適用不可';
  const isInsuranceStyle = isInsurance ? 'applied' : 'no-apply';

  return (
    <div className={'repair-item-select-card'}>
      <div className={'repair-item-select-header'}>
        <div className={'item-label'}>
          <span>{repairItemName}</span>
        </div>
        {isInsurance !== undefined && (
          <div className={`insurance-status ${isInsuranceStyle}`}>
            <span>{isInsuranceStatus}</span>
          </div>
        )}
      </div>
      <div className={'repair-item-select-body'}>
        <div className={'select-group'}>
          <RadioGroup
            list={selectList}
            groupName={`${repairItemName}_${itemIndex}`}
            value={selectList.indexOf(selectValue)}
            onChange={onChange}
          />
        </div>
        <div className={'amount-group'}>
          {amountList.map((amount, idx) => (
            <div className={'amount-label'} key={idx}>
              <span>{amount}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
